export default {
  SUPPLIERS_LIST: "Suppliers list",
  ADD_SUPPLIER: "Add supplier",
  SUPPLIER_ADDED: "Supplier added",
  EDIT_SUPPLIER: "Edit supplier",
  SUPPLIER_UPDATED: "Supplier updated",
  DELETE_THIS_SUPPLIER: "Delete this supplier?",
  SUPPLIER_DELETED: "Supplier deleted",
};
